import { render, staticRenderFns } from "./ParcelshopPicker.vue?vue&type=template&id=fa59cbcc"
import script from "./ParcelshopPicker.vue?vue&type=script&lang=js"
export * from "./ParcelshopPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../tracking/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports